import { createContext, useState } from 'react';

import ClubBaseInfoData from './ClubBaseInfoData';

export const ClubBaseInfoStateContext = createContext();

const ClubBaseInfoContextProvider = ({ children }) => {
  const stateHook = useState(ClubBaseInfoData.INITIAL_STATE);

  return (
    <ClubBaseInfoStateContext.Provider value={stateHook}>
      {children}
    </ClubBaseInfoStateContext.Provider>
  );
};

export default ClubBaseInfoContextProvider;